export default __webpack_public_path__ + "static/media/menu.91f2ddfe.svg";